import { styled } from "baseui";
import type { JustifyContent } from "baseui/block";

export const Column = styled<{ $gap?: string | number; $align?: JustifyContent }, "div">("div", (props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: props.$align,
  gap: props.$gap,
}));
